import { isBefore, subMonths } from "date-fns";

import { FILTER } from "@/constants";
import { useEpisodes } from "@/contexts/EpisodesContext";
import { useMentionCards } from "@/contexts/MentionCardsContext";
import { useFilterParamsV4 } from "@/hooks/useFilterParams";

import MentionsViewEmpty from "./Empty";
import EmptyTimePeriod from "./EmptyTimePeriod";
import FilteredEmpty from "./FilteredEmpty";
import GenericError from "./GenericError";
import { Organization } from "@/types/Organization";
import { hasValidFilters } from "@components/SearchFilter/utils";

const AllMessages: React.FC<{
  v4?: boolean;
  orgUuid: Organization["uuid"];
}> = ({ v4 = false, orgUuid }) => {
  const legacyEpisodesResult = useEpisodes();
  const mentionCardsResult = useMentionCards();

  const alert = v4 ? mentionCardsResult.alert : legacyEpisodesResult.alert;
  const errors = v4 ? mentionCardsResult.errors : legacyEpisodesResult.errors;
  const episodes = v4
    ? mentionCardsResult.mentionCards
    : legacyEpisodesResult.episodes;

  const [filters] = useFilterParamsV4();

  // the start date is already set to start date of the alert
  const filterStartDateIsAlertStart =
    alert?.start_date === filters[FILTER.START_DATE];

  // the start date is either within the default range ( 3 months )
  const alertIsNewerThan3Months = alert?.start_date
    ? isBefore(subMonths(new Date(), 3), new Date(alert.start_date))
    : false;
  const unFiltered = hasValidFilters(filters) === false;
  const onlyOneFilterActive = Object.keys(filters).length === 1;

  const newUnfiltered = alertIsNewerThan3Months && unFiltered;
  const isHistoricallyEmpty =
    // there are no episodes
    episodes?.length === 0 &&
    (newUnfiltered ||
      (filterStartDateIsAlertStart &&
        // and the date is the only parameter
        onlyOneFilterActive));

  return errors?.length ? (
    <GenericError />
  ) : isHistoricallyEmpty ? (
    <MentionsViewEmpty orgUuid={orgUuid} />
  ) : unFiltered ? (
    <EmptyTimePeriod searchStartDate={alert?.start_date} />
  ) : (
    <FilteredEmpty />
  );
};

export default AllMessages;
